<template lang="pug">
include ../pug/svg
section#learning
	div#ctrl
		div
			Search(v-model:search="search")
			Filter(id="statusFilter" label="Status" title="Status" :options="statusFilters" v-model:selected="statusFilter")
			button.but.circ.plus.text(v-if="hasFeature('course','add')" type="button" @click="toggleAddModal(true)")
				span Add {{terminology('course','course','singular')}}
				+svg(svg-filename="iconPlus" aria-hidden="true" alt="Add icon")
	div.wrapper
		div.c1.listbg
			ul.list
				li.course(v-for="(course, index) in filteredCourses" :key="course.id" :course="course" :index="index" @mouseenter="previewIndex=index" :class="{active:previewIndex===index}")
					picture
						img(v-if="course.media" :src="course.media.mediaUrl" :alt="course.media.seoAlt")
						img(v-else-if="course.mediaEmbedUrl" :src="course.mediaEmbedUrl")
					div.hgroup
						h2 {{course.name}}
						h3 {{courseStatus(course.publishStatus)}}
					a.arrow View {{terminology('course','course','singular')}}
						+svg(svg-filename='iconArrow')
					div(v-if="hasFeature('course','content')").butmore
						AppLink(v-if="hasFeature('course','content')" :to="{name:'ManageLearningCourseContent', params:{courseId:course.id}}") Edit Content
						AppLink(v-else :to="{name:'ManageLearningCourseActivity', params:{courseId:course.id}}") View Activity
						button.but(type="button" aria-haspopup="true" aria-controls="" @mouseenter="toggleTint(true),setMenu($event)" @mouseleave="toggleTint(false)") More
							+svg(svg-filename="iconMore" aria-hidden="true" alt="More icon")
						nav.menu(@mouseenter="toggleTint(true)" @mouseleave="toggleTint(false)")
							div.bar
								+svg(svg-filename="iconMore" aria-hidden="true")
								button.but(type="button") Close
									+svg(svg-filename="iconClose")
							ul
								li(v-if="hasFeature('course','settings')")
									AppLink(:to="{name:'ManageLearningCourseSettings', params:{courseId:course.id}}") Edit Settings
								li(v-if="hasFeature('course','access')")
									AppLink(:to="{name:'ManageLearningCourseAccess', params:{courseId:course.id}}") Edit Access
								li(v-if="hasFeature('course','activity') && hasFeature('course','content')")
									AppLink(:to="{name:'ManageLearningCourseActivity', params:{courseId:course.id}}") View Activity
								//-li
									AppLink(:to="{name:'ManageLearningCourseFeedback', params:{courseId:course.id}}") View Feedback
								li(v-if="hasFeature('course','add')")
									a(@click="showDuplicationModal(course)") Duplicate {{terminology('course','course','singular')}}				
								li(v-if="hasFeature('course','archive')")
									a(@click="archiveCourse(course)").bin Archive {{terminology('course','course','singular')}}
										+svg(svg-filename="iconBin" aria-hidden="true" alt="Bin icon")
					AppLink.but.pri(v-else :to="{name:'ManageLearningCourseActivity', params:{courseId:course.id}}") View Activity
		div.c2.sticky(v-if="previewCourse")
			div.preview
				figure
					picture
						img(v-if="previewCourse.media" :src="previewCourse.media.mediaUrl" :alt="previewCourse.media.seoAlt")
						img(v-else-if="previewCourse.mediaEmbedUrl" :src="previewCourse.mediaEmbedUrl")
					figcaption
						span {{previewCourse.name}}
				div.body
					//-h5 Learning Summary
					//-picture.user(v-if="user.profileUrl" :class="{online:user.online}")
						img(:src="user.profileUrl" width="40" height="40" :alt="user.fullName")
					//-pre {{previewCourse.counts}}
					h5 Course Summary
					table.numeric
						tr
							th {{terminology('course','section','plural')}}
							th {{terminology('course','lesson','plural')}}
							//-th {{terminology('course','block','plural')}}
							th {{terminology('course','task','plural')}}
							th {{terminology('user','learner','plural')}}
						//-tr
							td {{previewCourse.courseSections.length}}
							td {{previewCourse.courseLessons.length}}
							td {{lessonBlockCount(previewCourse)}}
						tr
							td {{previewCourse.counts.section}}
							td {{previewCourse.counts.lesson}}
							//-td {{previewCourse.counts.block}}
							td {{previewCourse.counts.task}}
							td {{previewCourse.counts.learner}}

					//-h5 {{terminology('user','user','singular')}} Summary
					//-table.numeric
						tr
							//-th {{terminology('user','admin','plural')}}
							//-th {{terminology('user','mentor','plural')}}
							th {{terminology('user','learner','plural')}}
						//-tr
							td {{courseAdminCount(previewCourse)}}
							td {{courseMentorCount(previewCourse)}}
							td {{courseLearnerCount(previewCourse)}}
						tr
							td {{previewCourse.counts.learner}}
					//-h5 Avg. Feedback Score
					//-ol.rating
						li(:class="avgFeedbackClass(previewCourse, 0)") 1 Star
							+svg(svg-filename="iconStar" aria-hidden="true" alt="Star icon")
						li(:class="avgFeedbackClass(previewCourse, 1)") 2 Star
							+svg(svg-filename="iconStar" aria-hidden="true" alt="Star icon")
						li(:class="avgFeedbackClass(previewCourse, 2)") 3 Star
							+svg(svg-filename="iconStar" aria-hidden="true" alt="Star icon")
						li(:class="avgFeedbackClass(previewCourse, 3)") 4 Star
							+svg(svg-filename="iconStar" aria-hidden="true" alt="Star icon")
						li(:class="avgFeedbackClass(previewCourse, 4)") 5 Star
							+svg(svg-filename="iconStar" aria-hidden="true" alt="Star icon")
					template(v-if="previewCourse.examMode")
						h5 Result Summary
						table.numeric
							tr
								th Attempts
								th Pending
								th Passes
								th Fails
							//-tr
								td {{courseAttempCount(previewCourse)}}
								td {{coursePassCount(previewCourse)}}
								td {{courseFailCount(previewCourse)}}
							tr
								td {{previewCourse.counts.attempt}}
								//-td {{previewCourse.counts.pending}}
								//-td {{previewCourse.counts.pass}}
								//-td {{previewCourse.counts.fail}}
								td -
								td -
								td -
	div#add-course.modal.center(:class="{active:addModal}")
		div.bar
			+svg(svg-filename="iconMore" aria-hidden="true")
			span Add {{terminology('course','course','singular')}}
			button.but(type="button" @click="toggleAddModal(false)") Close
				+svg(svg-filename="iconClose")
		div.body
			Form.fgroup(ref="form" :validation-schema="courseSchema" v-slot="{ errors, isSubmitting, values, meta }" @submit="addCourse")
				//-pre values: {{values}}
				div.field.grow
					Field(name="name" type="text" placeholder="Unsupplied" autocomplete="off" :validateOnInput="false" required)
					label Name
					transition(name="fade")
						ErrorMessage.err(name="name" as="span")
				div.foot
					span.req Required
					button.but.pri.spinner(type="submit" :class="{spin:isSubmitting}" :disabled="!meta.valid||isSubmitting") Save
					button.but.sec(type="button" @click="toggleAddModal(false)") Cancel
					
	div#duplicate-course.modal.center(:class="{active:duplicationModal}")
		div.bar
			+svg(svg-filename="iconMore" aria-hidden="true")
			span Duplicate {{terminology('course','course','singular')}}
			button.but(type="button" @click="hideDuplicationModal") Close
				+svg(svg-filename="iconClose")
		Form.body(ref="formDuplication" :validation-schema="duplicationSchema" v-slot="{ errors, isSubmitting, values, meta }" @submit="duplicate")
			transition(name="modalform")
				fieldset
					FieldText(name="duplicationName" type="text" v-model="duplicationName" :required="true" :label="'New '+terminology('course','course','singular')+' Name'")
					FieldText(v-if="duplicationOrgOpts.length===1" name="duplicationOrg" type="hidden" v-model="duplicationOrg")
					FieldSelect(v-else name="duplicationOrg" :label="'Recipient '+terminology('organisation','organisation','singular')" v-model="duplicationOrg" :options="duplicationOrgOpts" :required="true" :errors="errors")
			div.foot
				span.req Required
				button.but.pri.spinner(type="submit" :class="{spin:isSubmitting||processing}" :disabled="!meta.valid||isSubmitting") Duplicate
					+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
				button.but.sec(type="button" @click="hideDuplicationModal") Cancel
</template>

<script>
import Search from '../components/Search';
import Filter from '../components/Filter';
import FieldText from '../components/FieldText';
import FieldSelect from '../components/FieldSelect';
import CourseService from '../services/CourseService';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';

export default {
	name: 'ManageLearning',
	components: {
		Form,
		Field,
		ErrorMessage,
		FieldText,
		FieldSelect,
		Search,
		Filter,
	},
	mounted() {
		this.$store.dispatch('gui/setHeader', {
			title: 'Manage ' + this.terminology('course','course','plural'),
			backRoute: {
				text: 'Dashboard',
				name: 'Dashboard',
			},			
		});
		
		if (this.$route.query.ids) {
			// validate passed ids
			if (this.$route.query.ids.match(this.idRegex)) {
				this.search = this.$route.query.ids;
			}
		}
		
		// initate selection of only option
		if (this.duplicationOrgOpts.length === 1) {			
			this.duplicationOrg = this.duplicationOrgOpts[0].value;
		}
		
		this.refreshCourses();
	},
	data() {
		const req = 'Required';
		const courseSchema = Yup.object().shape({
			name: Yup.string().label('Name').required(req),
		});
		
		const duplicationSchema = Yup.object().shape({
			duplicationOrg: Yup.string().required(req).nullable(),
			duplicationName: Yup.string().required(req).nullable(),
		});
		
		return {
			courseSchema,
			duplicationSchema,
			addModal: false,
			duplicationModal: false,
			duplicationOrg: null,
			duplicationName: null,
			processing: false,
			search: null,
			statusFilter: null,
			previewIndex: 0,
			idRegex: /^[0-9]+(,[0-9]+)*$/,
		}
	},
	computed: {
		usr() {
			return this.$store.state.auth.user;
		},
		userSeniority() {
			return this.$store.getters['auth/getUserSeniority'];
		},
		courses() {
			return this.$store.getters['courses/getCourses'];
		},
		statusFilters() {
			return this.$store.state.courses.courseStatuses;
		},
		duplicationOrgOpts() {
			return this.$store.getters['auth/getUserOrganisationOpts'];
		},
		filteredCourses() {
			// apply status filter
			const selected = this.statusFilter?.value || null;
			let f1 = (selected) ? this.courses.filter(c => c.publishStatus === selected) : this.courses.filter(c => c.publishStatus !== 'archive');
			
			// exclude courses auth user is asigned to
			let f2 = f1.filter(c => !c.courseUsers.some(u => u.userOrganisation.userId === this.usr.id && u.role.slug === 'learner'));
			
			// serch term filter
			if (this.search) {				
				if (this.search.match(this.idRegex) !== null) {
					// id search
					const ids = this.search.split(',').map(id => { 
						return parseInt(id);
					});
					
					return f2.filter(c => ids.includes(c.id));
					
				} else {
					// name search
					return f2.filter(c => c.name.toLowerCase().includes(this.search.toLowerCase()));
				}
				
			} else {
				return f2;
			}					
		},
		previewCourse() {
			return this.filteredCourses[this.previewIndex];
		},
	},
	methods: {
		hasFeature(feature, subfeature) {
			return this.$store.getters['gui/hasFeature'](feature, subfeature);
		},
		userCourseRole(courseId) {
			return this.$store.getters['courses/getUserCourseRole'](courseId);
		},
		setMenu(event) {
			if (event.target.nodeName === 'BUTTON' && event.relatedTarget.nodeName !== 'NAV') {
				const menu = event.target.nextSibling;
				menu.classList.remove('reverse');				
				const rect = menu.getBoundingClientRect();
				
				if (rect.bottom > window.innerHeight) {
					menu.classList.add('reverse');
				}
			}
		},
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
		toggleTint(bool) {
			if (this.duplicationModal) {
				return;
			}
			
			this.$store.dispatch('gui/setTintState', bool);
		},
		toggleAddModal(bool) {
			this.toggleTint(bool);
			this.addModal = bool;
		},
		showDuplicationModal(course) {
			this.toggleTint(true);
			this.duplicationModal = course;
			this.duplicationName = 'Clone - '+course.name;
			
			if (this.duplicationOrgOpts.length === 1) {
				this.$refs.formDuplication.validate();
			}			
		},
		hideDuplicationModal() {
			// hide modal
			this.duplicationModal = false;
			this.toggleTint(false);
			// reset values
			this.duplicationOrg = null;
			this.duplicationName = null;
			// reset form
			const form = this.$refs.formDuplication;
			
			for(const field in form.getValues()) {
				let value = null;
				
				form.resetField(field, {
					value,
				});						
			}
		},
		async duplicate(formData) {
			try {
				this.processing = true;
				
				const delay = this.$store.getters['gui/delay'];
				
				const {data} = await CourseService.cloneCourse({
					// donor data
					courseId: this.duplicationModal.id,
					courseName: formData.duplicationName,
					// recipient data
					organisationId: formData.duplicationOrg,
				});
				
				if (data.refreshCourses) {
					this.refreshCourses();
				}
				
				await delay;
				
				this.processing = false;
				
				this.$store.dispatch('gui/setNotification', {
					dismiss: true,
					message: 'The ' + this.terminology('course', 'course', 'singular') + ' was successfully cloned',
				});
				
				this.hideDuplicationModal();
				
			} catch (error) {
				console.log(error);
			}
		},
		lessonBlockCount(course) {
			const blocks = course.courseLessons.map(l => l.blockData.blocks);
			let count = 0;
			
			for (let block of blocks) {
				count += block.length;
			}
			
			return count;
		},
		courseStatus(publishStatus) {
			const status = this.statusFilters.find(s => s.value === publishStatus);
			return status.option;
		},
		courseAdminCount(course) {
			const admins = course.courseUsers.filter(u => u.role.slug === 'admin');
			return admins.length;
		},
		courseMentorCount(course) {
			const mentors = course.courseUsers.filter(u => u.role.slug === 'mentor');
			return mentors.length;
		},
		courseLearnerCount(course) {
			const learners = course.courseUsers.filter(u => u.role.slug === 'learner');
			return learners.length;
		},
		avgFeedbackClass(course, rating) {
			const score = this.$store.getters['courses/getAvgFeedbackScore'](course.id);
			
			if (score >= rating+1) {
				return 'full';	
				
			} else if (score >= rating)  {
				return 'half';
			}
			
			return null;
		},
		/*courseAttempCount(course) {
			return this.$store.getters['courses/getCompletedAttemptCount'](course.id);
		},
		coursePassCount(course) {
			return this.$store.getters['courses/getCompletedPassCount'](course.id);
		},
		courseFailCount(course) {
			return this.$store.getters['courses/getCompletedFailCount'](course.id);
		},*/
		slugify(string) {
			return string.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
		},
		async addCourse(values, actions) {
			try {
				const response = await CourseService.createCourse({
					name: values.name,
					slug: this.slugify(values.name),
				});
				
				if (response.status === 200) {
					this.$store.dispatch('gui/setNotification', {
						dismiss: true,
						message: 'The ' + this.terminology('course', 'course', 'singular') + ' was successfully created',
					});
					
					this.toggleAddModal(false);
					this.refreshCourses();
					actions.resetForm();
				}
				
			} catch(err) {
				actions.setFieldError('name', err.response.data.message);
			}
		},
		async archiveCourse(course) {
			try {
				await CourseService.archiveCourse({id:course.id});
				
				this.$store.dispatch('gui/setNotification', {
					dismiss: true,
					message: 'The ' + this.terminology('course', 'course', 'singular') + ' was successfully archived',
				});
				
				this.refreshCourses();
				
			} catch(err) {
				console.log('err:', err);
			}
		},
		async refreshCourses() {
			//const before = new Date();
			//console.log('before:', before.getTime());
			// load courses from db
			await this.$store.dispatch('courses/dbCourses');
			//const after = new Date();
			//const seconds = (after.getTime() - before.getTime()) / 1000;
			//console.log('seconds:', seconds);
		},
	},
}
</script>

<style lang="scss">
	#duplicate-course {
		.field {
			max-width: none;
		}
	}
</style>
